export default __webpack_public_path__ + "25ba55aab91c340888d3d64e81811776.svg";